export default "__VITE_ASSET__CHQTrogt__"